var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.title)?_c('div',{staticClass:"simple-section--title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_c('div',{staticClass:"simple-section--content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }